import { GfaDealerContextServiceV1 } from '@volkswagen-onehub/gfa-dealer-context-service';

class MyDealerService {
	private static instance: MyDealerService;
	private service: GfaDealerContextServiceV1 | undefined;

	private constructor() {}

	static getInstance(): MyDealerService {
		if (!MyDealerService.instance) {
			MyDealerService.instance = new MyDealerService();
		}
		return MyDealerService.instance;
	}

	init(service: GfaDealerContextServiceV1 | undefined): void {
		this.service = service;
	}

	get currentDealerId(): string | undefined {
		return this.service?.getSelectedDealer()?.id;
	}
}

export const myDealerService = MyDealerService.getInstance();
